import { render, staticRenderFns } from "./Disclosure.vue?vue&type=template&id=ecd93454"
import script from "./Disclosure.vue?vue&type=script&lang=js"
export * from "./Disclosure.vue?vue&type=script&lang=js"
import style0 from "./Disclosure.vue?vue&type=style&index=0&id=ecd93454&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports